<!-- <template>
	<div class="module_container full" style="position: relative;">
		<vxe-grid v-bind="gridOptions" :key="gridKey" v-if="gridOptions" @toolbar-button-click="toolbarButtonClickEvent"
			:ref="moduleName+'_list'">
		</vxe-grid>
		<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />


	</div>
</template>
<style>

</style>
<style scoped>

</style> -->
<script>
	import listBase from '@_system/components/base/list.vue'
	import taxinfo from './taxinfo/index.vue'
	export default {
		extends: listBase,
		name: 'companyIndex',
		props: {

		},
		render(h) {
			this.$slots.plug = [
				<taxinfo ref="taxinfo"  row={this.currentRow} onSubmit={this.taxinfoSubmit} />,
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'company',
				windowName: '开票公司',
				currentRow:{}
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			beforeCreateGrid(formConfig,columns){
				columns.unshift({
					type:"radio",
					fixed:"left",
					width:50
				})
				console.log(columns)
			},
			taxinfo(){
				this.$refs.taxinfo.modal_show()
			},
			taxinfoSubmit(){
				
			},
			show() {

			},
			hide() {

			},
		},
		components: {
			taxinfo
		}
	}
</script>
